import React from 'react'
import Create from '../crud/create'
import fields from './fields'
import menuItems from './menuItems'

const CreateProductCategory = (props) => {
  return (
    <Create
// @ts-ignore
      title='Add Product to Category'
      fields={fields}
      apiPath='admin/product_categories'
      successRedirectPath={resource => `/ecommerce/product-categories/${resource.id}/edit`}
      buildMenuItems={menuItems}
    />
  )
}

export default CreateProductCategory
